import LegalLayout, { H2, H3, UL } from "@/components/layout/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout titleKey="cookies" title="Cookie Policy" testId="legal-cookies-page">
      <H2>What Are Cookies?</H2>
      <p>Cookies are small text files stored on your device that help websites function properly, improve performance, remember preferences, and provide analytics.</p>
      <p>This Cookie Policy applies to AtlasForge Financial, Safe to Spend 365, Ember360, our websites, applications, and APIs.</p>

      <H2>Types of Cookies We Use</H2>
      <H3>Essential Cookies</H3>
      <p>Required for:</p>
      <UL items={["Authentication", "Security", "Session management", "Fraud prevention"]} />
      <p>These cookies cannot be disabled.</p>

      <H3>Functional Cookies</H3>
      <p>Used to:</p>
      <UL items={["Remember preferences", "Save settings", "Improve user experience"]} />

      <H3>Analytics Cookies</H3>
      <p>Used to understand:</p>
      <UL items={["Website traffic", "Product usage", "Feature adoption", "Performance metrics"]} />
      <p>Examples may include Google Analytics or similar services.</p>

      <H3>Marketing Cookies</H3>
      <p>May be used to:</p>
      <UL items={["Measure advertising effectiveness", "Deliver relevant marketing content"]} />

      <H2>Managing Cookies</H2>
      <p>Most browsers allow users to:</p>
      <UL items={["View cookies", "Delete cookies", "Block cookies", "Restrict third-party cookies"]} />
      <p>Disabling certain cookies may affect functionality.</p>

      <H2>Contact</H2>
      <p>customersupport@atlasforgefinancial.com</p>
      <p>843-291-2556</p>
    </LegalLayout>
  );
}
